import { Serializable } from "../utilities/Serializable";
import { PoS } from "./PoS";
import { DailyTotal } from "./DailyTotal";
import { User } from "./User";

export class RegisterActivity extends Serializable {
    uuid: string;
    opendDate: string;
    closeDate: string;
    lastCardTransactionDate: string;
    pos: PoS;
    dailyTotals: DailyTotal[];
    total: number;
    openingOperator: User;
    closingOperator: User;
    totalReversed: number;
    totalRecharged: number;
    totalDischarged: number;

    constructor() {
        super();
    }

}


// WEBPACK FOOTER //
// ./src/app/models/RegisterActivity.ts